<template>
  <div></div>
</template>

<script>
import { AVRProducts } from '@/utils/enums';

export default {
  name: 'redirectEntryRoute',
  data() {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    /** Current caveat - the route directly used with this component
      will be in the route history creating a loop when navigating backwards.
      Only use for entry routes of a product.
    */
    next(vm => {
      vm.redirectRoute(to, from);
    });
  },
  methods: {
    // eslint-disable-next-line no-unused-vars,consistent-return
    redirectRoute(to, from) {
      try {
        switch (this.$store.getters.getCurrentProduct) {
          case AVRProducts.CREDIT:
            this.$router.push(this.$store.getters.getProductHomeRoute(AVRProducts.CREDIT));
            break;
          case AVRProducts.TRADE:
            this.$router.push(this.$store.getters.getProductHomeRoute(AVRProducts.TRADE));
            break;
          case AVRProducts.TEST_DRIVE:
            this.$router.push(this.$store.getters.getProductHomeRoute(AVRProducts.TEST_DRIVE));
            break;
          case AVRProducts.INSURANCE:
            this.$router.push(this.$store.getters.getProductHomeRoute(AVRProducts.INSURANCE));
            break;
          case AVRProducts.ACQUIRE:
            this.$router.push(this.$store.getters.getProductHomeRoute(AVRProducts.ACQUIRE));
            break;
          default:
            throw new Error(`Product not supported: ${this.$store.getters.getCurrentProduct}`);
        }
      } catch (error) {
        this.$log(`Redirect entry route failed: ${to.path}`, error);
        this.$router.push('/error');
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
